import { createSlice } from '@reduxjs/toolkit';
import { Error } from '../../../Data/error.dto';
import { InvoiceReducer } from '../../Reducers/Dashboard/InvoiceReducer';
import type { Invoice, InvoiceSummary } from '../../../Data/invoice.dto';

export interface InvoiceState {
  loading: boolean;     
  submitting: boolean;    
  allInvoices: InvoiceSummary[];
  totalCount: number;
  currentInvoice: Invoice | null;
  error: Error;
  isError: boolean;
}

const initialState: InvoiceState = {
  loading: false,
  submitting: false,
  allInvoices: [],
  totalCount: 0,
  currentInvoice: null,
  error: {},
  isError: false,
};

const InvoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    InvoiceReducer(builder);
  },
});

export const {} = InvoiceSlice.actions;
export default InvoiceSlice.reducer;
